'use client';

import { useParams } from 'next/navigation';
import { CatButton } from '../../blocks-components';
import { useTranslations } from 'next-intl';
import { getPDPUrl } from 'components/product-comparison-grid/product-comparison-card/utils';
import Link from 'next/link';
import { MouseEvent } from 'react';

interface ViewDetailsProps {
  partNumber: string;
  isHeadlessPDPEnabled?: boolean;
  productURL?: string;
}

export default function ViewDetails({
  partNumber,
  isHeadlessPDPEnabled,
  productURL = ''
}: Readonly<ViewDetailsProps>) {
  const t = useTranslations();
  const esiteParams = useParams();

  const pdpURL = getPDPUrl({
    esiteParams,
    isHeadlessPDPEnabled,
    productNumber: partNumber,
    productURL
  });

  const viewDetailsCallback = (e: MouseEvent) => {
    if (!isHeadlessPDPEnabled) {
      e.preventDefault();
      window.location.href = pdpURL;
    }
  };

  return (
    <Link
      className="w-100"
      key={pdpURL}
      href={pdpURL}
      onClick={viewDetailsCallback}
    >
      <CatButton size="md" fullWidth>
        {t('VIEW_DETAILS')}
      </CatButton>
    </Link>
  );
}
